<template>
<div  class="top-count-row">
   
            <!-- <div v-if="sysBookingNum && sysBookingNum.pendingagents" class="box-wrapper">
                <div class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/smiley.svg" alt="">
                        </div>
                        <div class="name-t">
                            Pending Agent Registration
                        </div>
                    </div>
                    <div  class="right">
                        <div class="number">
                            {{sysBookingNum.pendingagents}}
                        </div>
                    </div>


                </div>
                <div class="bottom">
                    <div class="progressbar">
                        <CProgress
                                class="progress-sm mt-2"
                                :precision="1"
                                color="info"
                                :value="50"
                        />
                    </div>
                </div>
            </div> -->

            <div v-if="sysBookingNum" class="box-wrapper">
                
                <div class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                        </div>
                        <div class="name-t">
                            {{$t("dashBoard.cAgtDBBookingNo.todaySales")}}
                        </div>
                    </div>
                    <div  class="right">
                        
                        <div class="number">
                            
                            {{sysBookingNum.sales}}
                        </div>
                    </div>

                     <div  v-if="sysBookingNum.sales==null" class="right">
                    <div class="number">
                            $ 0 
                        </div>
                        </div>


                </div>
                <div class="bottom">
                    <div class="progressbar">
                        <div class="progress-bar-wrap">
                            <CProgress
                                    class="progress-sm mt-2"
                                    :precision="1"
                                    color="purple "
                                    :value="56"
                            />
                        </div>
                    </div>
                </div>
            </div>
           
            <div v-if="sysBookingNum" class="box-wrapper">
                
                <div class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/coin.svg" alt="">
                        </div>
                        <div class="name-t">  {{selAgent.reportType=='TODAY'?$t("dashBoard.cAgtDBBookingNo.todaySales"):selAgent.reportType=='THISMONTH'?$t("dashBoard.cAgtDBBookingNo.monthlySales"):selAgent.reportType=='THISWEEK'?$t("dashBoard.cAgtDBBookingNo.weeklySales"):$t("dashBoard.cAgtDBBookingNo.sales")}}
                           
                        </div>
                    </div>
                    
                    <div v-if="sysBookingNum.sales" class="right flex-flow-column">
                      <div class="number" v-for="(sales,index) in sysBookingNum.sales" :key="'sales'+index">
                          {{Object.keys(sales)+' '+Object.values(sales)}}
                      </div>
                       
                        
                    </div>
                    <div  v-if="sysBookingNum.sales==null" class="right">
                    <div class="number">
                            $ 0 
                        </div>
                        </div>
                </div>
                <div class="bottom">
                   
                    <div class="progressbar">
                        <CProgress
                                class="progress-sm mt-2"
                                :precision="1"
                                color="green"
                                :value="50"
                        />
                    </div>
                </div>
            </div>

            <div v-if="sysBookingNum" class="box-wrapper">
                <div v-if="isAgentGroup==false" class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                        </div>
                        <div class="name-t">
                             {{selAgent.reportType=='TODAY'?$t("dashBoard.cAgtDBBookingNo.todayIssuedBooking"):selAgent.reportType=='THISMONTH'?$t("dashBoard.cAgtDBBookingNo.monthlyIssuedBooking"):selAgent.reportType=='THISWEEK'?$t("dashBoard.cAgtDBBookingNo.weeklyIssuedBooking"):$t("dashBoard.cAgtDBBookingNo.issuedBooking")}} 
                           
                        </div>
                    </div>
                    <div  class="right">
                        <div class="number">
                            <!-- 23 -->
                            {{sysBookingNum.issuedbookings?sysBookingNum.issuedbookings:0}}
                        </div>
                    </div>


                </div>
                <div v-if="isAgentGroup" class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                        </div>
                        <div class="name-t">
                             <!-- {{selAgent.reportType=='TODAY'?$t("dashBoard.cAgtDBBookingNo.todayIssuedBooking"):selAgent.reportType=='THISMONTH'?$t("dashBoard.cAgtDBBookingNo.monthlyIssuedBooking"):selAgent.reportType=='THISWEEK'?$t("dashBoard.cAgtDBBookingNo.weeklyIssuedBooking"):$t("dashBoard.cAgtDBBookingNo.issuedBooking")}}  -->
                           Total Cash Sale
                        </div>
                    </div>
                    <div  class="right">
                        <div class="number" v-if="sysBookingNum.totalcashsalesamount">
                            <!-- 23 -->
                            {{sysBookingNum.currency+' '}}{{sysBookingNum.totalcashsalesamount|formatNumber(sysBookingNum.currency)}}
                        </div>
                        <div class="number" v-else>
                          {{sysBookingNum.currency+' '}}{{0}}
                        </div>
                    </div>


                </div>
                <div class="bottom">
                    <div class="progressbar">
                        <div class="progress-bar-wrap">
                            <CProgress
                                    class="progress-sm mt-2"
                                    :precision="1"
                                    color="purple "
                                    :value="56"
                            />
                        </div>
                    </div>
                </div>
               
            </div>

            <div v-if="sysBookingNum && isAgentGroup" class="box-wrapper">
                <div v-if="isAgentGroup" class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                        </div>
                        <div class="name-t">
                             <!-- {{selAgent.reportType=='TODAY'?$t("dashBoard.cAgtDBBookingNo.todayIssuedBooking"):selAgent.reportType=='THISMONTH'?$t("dashBoard.cAgtDBBookingNo.monthlyIssuedBooking"):selAgent.reportType=='THISWEEK'?$t("dashBoard.cAgtDBBookingNo.weeklyIssuedBooking"):$t("dashBoard.cAgtDBBookingNo.issuedBooking")}}  -->
                           Outstanding Credit Sale
                        </div>
                    </div>
                    <div  class="right">
                        <div class="number" v-if="sysBookingNum.totalcreditsalesamount">
                            <!-- 23 -->
                           {{sysBookingNum.currency+' '}} {{sysBookingNum.totalcreditsalesamount|formatNumber(sysBookingNum.currency)}}
                        </div>
                        <div class="number" v-else>
                            <!-- 23 -->
                            {{sysBookingNum.currency+' '}}{{0}}
                        </div>
                    </div>


                </div>
                <div class="bottom">
                    <div class="progressbar">
                        <div class="progress-bar-wrap">
                            <CProgress
                                    class="progress-sm mt-2"
                                    :precision="1"
                                    color="yellow "
                                    :value="56"
                            />
                        </div>
                    </div>
                </div>
               
            </div>

             <div v-if="sysBookingNum && isAgentGroup" class="box-wrapper">
                <div v-if="isAgentGroup" class="top">
                    <div class="left">
                        <div class="icon">
                            <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                        </div>
                        <div class="name-t">
                             <!-- {{selAgent.reportType=='TODAY'?$t("dashBoard.cAgtDBBookingNo.todayIssuedBooking"):selAgent.reportType=='THISMONTH'?$t("dashBoard.cAgtDBBookingNo.monthlyIssuedBooking"):selAgent.reportType=='THISWEEK'?$t("dashBoard.cAgtDBBookingNo.weeklyIssuedBooking"):$t("dashBoard.cAgtDBBookingNo.issuedBooking")}}  -->
                           Selected Period of Total Sales
                        </div>
                    </div>
                    <div  class="right">
                        <div class="number" v-if="sysBookingNum.totalsalesamount">
                            <!-- 23 -->
                            {{sysBookingNum.currency+' '}}{{sysBookingNum.totalsalesamount|formatNumber(sysBookingNum.currency)}}
                        </div>
                          <div class="number" v-else>
                            <!-- 23 -->
                            {{sysBookingNum.currency+' '}}{{0}}
                        </div>
                    </div>


                </div>
                <div class="bottom">
                    <div class="progressbar">
                        <div class="progress-bar-wrap">
                            <CProgress
                                    class="progress-sm mt-2"
                                    :precision="1"
                                    color="blue "
                                    :value="56"
                            />
                        </div>
                    </div>
                </div>
               
            </div>

            <div v-if="!isAgentGroup && sysBookingNum && sysBookingNum.pendingstatements && balDet" class="box-wrapper d-flex justify-content-between flex-flow-column">
                <div class="top">
                    <div class="left">
                        <div class="d-flex">
                            <div class="icon mt-auto mb-auto">
                                <img src="@imgPath/img/svg/icons/analyse_primit.svg" alt="">
                            </div>
                            <div class= "ml-10px" :class="balDet.length!=0?'number':null">
                                {{sysBookingNum.pendingstatements}}
                            </div>
                        </div>



                    </div>
                    <div class="right mb-3" >
                    <div class="number  ml-auto" v-for="(finance, index) in balDet" :key="index" >
                        <span v-if="finance.agenttype==agentType.prepaid && finance.prepaidbalance" class="d-flex flex-flow-column">
                       <span class="text-ellipsis">
                            {{finance.currecycode+' '}} {{finance.prepaidbalance | formatNumber(finance.currecycode)}}
                       </span>
                        </span>
                        <span v-if="finance.agenttype==agentType.postpaid && finance.postpaid_runningamount" class="d-flex flex-flow-column">
                            <span class="text-ellipsis">
                                 {{finance.currecycode+' '}} {{getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)|
                        formatNumber(finance.currecycode)}}
                            </span>
                        </span>
                    </div>

                </div>

                </div>
               
               
                <div class="bottom">
                    <div class="name-t pt-0">
                        {{$t("dashBoard.cAgtDBBookingNo.outstandingPostpaidInvoice")}}

                    </div>
                    <div class="progressbar">
                        <CProgress
                                class="progress-sm mt-2"
                                :precision="1"
                                color="red "
                                :value="50"
                        />
                    </div>
                </div>
            </div>

            <!-- <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{'ErrorCode: '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
      </CAlert>  -->

        </div>
</template>
<script>
import Logger from "../../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../../router/index";
import apiGetBalanceDetail from "../../../../services/apiGetBalanceDetail";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS, APPROVEAGENT } from "../../../../util/constants";
import BaseConfiguration from "../../../../config/base.js";
import SERVICE_URL from "../../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue, parseNumber } from "../../../../util/util";

export default {
  name: COMPONENT_NAME.C_AGT_DB_BOOKING_NUM,

  data () {
    return {
        // sysBookingNum : null,
       salesMaxVal: null,
       issuedMaxVal:null,
       balDet:null,
       agentType: {
                    prepaid: APPROVEAGENT.PREPAID,
                    postpaid: APPROVEAGENT.POSTPAID
                },
                alertValue:null
    }
   },

   props:{
       prgrsBarData:{
           type: Object,
           default:null
       },
       selAgent:{
           type: Object,
           default:null
       },
    //    status:{
    //        type: String,
    //        default:null
    //    },
       sysBookingNum:{
           type: Object,
           default:null
       },
       isAgentGroup: {
           type: Boolean,
           default: false
       }

   },

//    computed: {
//            ...mapGetters("sSysLogin", {
//       ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
//     }),
        // },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                // alert(this.prgrsBarData);
                if (BaseConfiguration.isDebug)console.log(this.selAgent)
                if (this.selAgent) {
                   await this.getBalanceDetail(this.selAgent.b2bid ? this.selAgent.b2bid : 
                   this.selAgent.groupId ? this.selAgent.groupId : null);
                
                //   this.toGetPrgrsBarMaxVal(this.prgrsBarData);
                   
                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_AGT_DB_BOOKING_NUM,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

  methods: {

      showAlert(val) {
                this.$emit("showAlert", val);
            },

      getPostPaidAmt(pPostPaidLimit, pPostPaidRunAmt) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPostPaidAmt");

                    retValue = parseNumber(pPostPaidLimit) - parseNumber(pPostPaidRunAmt);


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_AGT_DB_BOOKING_NUM,
                        "error in getPostPaidAmt",
                        err.toString(),
                        "getPostPaidAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


      toGetPrgrsBarMaxVal(pdayToDaySalesRes) {
          let sales=0;
          let issuedbookings=0;
          try {
            if(BaseConfiguration.isDebug) console.log("toGetPrgrsBarMaxVal");
           if(pdayToDaySalesRes){
              
                if(pdayToDaySalesRes.dayTodaySales.lastweek_sameday){
                    for (let i = 0; i < pdayToDaySalesRes.dayTodaySales.lastweek_sameday.length; i++) {
                        sales+=pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.Sales;
                        issuedbookings+=pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.IssuedBookings;
                      
                    }
                }
            } 
            this.salesMaxVal = sales;
            this.issuedMaxVal = issuedbookings;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_AGT_DB_BOOKING_NUM,
                    "error in toGetPrgrsBarMaxVal",
                    err.toString(),
                    "toGetPrgrsBarMaxVal",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 

          async getBalanceDetail(pB2bid) {
              let retValue;
              try {
                if(BaseConfiguration.isDebug) console.log("getBalanceDetail");
                let balanceReq = apiGetBalanceDetail.buildRequest(pB2bid);
                    if (balanceReq) {
                        let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
                        if (VALIDATE_SUCCESS_RES(balanceRes)) {
                            this.balDet =  balanceRes.data.data;
                        }
                        else {
                            let error = getErrorMessage(balanceRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.alertValue = getErrorAlertValue(error);
                            }
                        }
                    }else{
                        throw "invalid request";
                    }
              } catch (err) {
                      let body = Logger.buildRequest(
                        COMPONENT_NAME.C_AGT_DB_BOOKING_NUM,
                        "error in getBalanceDetail",
                        err.toString(),
                        "getBalanceDetail",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
                return retValue;
          }, 

         
     
  }
}

</script>
<style>
    main.c-main {
        background: #f2f4f5;
    }
    .box-wrapper {
        width: calc(100% / 4);
    }
</style>